/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

// Il questionario "Dicci la tua" di clienti e tecnici (migrazione 016).
export const feedbackAPI = {
  list: async (filtro = 'tutti') => {
    const { data } = await apiClient.get('/feedback', { params: { filtro } });
    return data;
  },

  segnaLetto: async (id, letto = true) => {
    const { data } = await apiClient.patch(`/feedback/${id}`, { letto });
    return data;
  },

  // Trasforma una risposta in una segnalazione da lavorare.
  inSegnalazione: async (id, payload) => {
    const { data } = await apiClient.post(`/feedback/${id}/segnalazione`, payload);
    return data;
  },
};
